
//polyfills
import 'core-js/es6/set';
import 'core-js/es6/map';
import 'core-js/es6/array';
import 'core-js/fn/array/for-each';
import 'core-js/fn/array/fill';
import 'core-js/fn/array/find';
import 'core-js/fn/number/is-nan';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/string/ends-with';
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support

import React from 'react';
import { render } from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { createStore, compose, applyMiddleware } from 'redux';

import wolfPacApp from './reducers';
import { AppStoreWrapper } from './components/App';

import 'bootstrap/dist/css/bootstrap.min.css';

import { unregister } from './registerServiceWorker';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(wolfPacApp, composeEnhancer(applyMiddleware(thunkMiddleware)));

render(
    <AppStoreWrapper store={store} />,
    document.getElementById('root')
);

unregister();
